<div class="advance-filter-container white-bg dropdown-shadow p-6 pt-8 radius-m">
    <div [ngClass]="mode==0?'top-wrapper':'top-wrapper_mod'" [formGroup]="advanceFilter">
        <ng-container *ngIf="mode == 0 || mode ==  1">
            <div class="relative-time-panel mr-8" [ngClass]="mode == 1 ? 'border-none' : 'border-light-right'">
                <!-- <div class="header content-xl">Relative Time</div> -->
                <div class="header content-xl">{{alertVarService.titles.templateTitles.advance_filter.relative_time}}</div>
                <div class="relative-time">
                    <ul class="content-m primary-text">
                        <ng-container
                            *ngFor="let relativeTime of advanceFilter_metadata.relative_time_options; index as i">
                            <li class="py-3" [ngClass]="ishighlight_relativetime==relativeTime.disp? 'highlight-relative':''"
                                (click)="relativeTime_click(relativeTime)">
                                {{relativeTime.disp}}
                            </li>
                        </ng-container>
                    </ul>
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="mode == 0 || mode ==  2">
            <div class="date-time-panel ">
                <div class="header content-xl">{{alertVarService.titles.templateTitles.advance_filter.custom_time_range}}</div>
                <div class="date-time-range pt-6">
                    <div class="time-inputs">
                        <div class="from-time">
                            <label>{{alertVarService.titles.templateTitles.advance_filter.start_time}}</label>
                            <input class="input-m" [min]="mindate" [max]="maxdate" type="datetime-local" formControlName="fromDate"
                                [tooltip]="fromDate.value | date:'dd MMM yy HH:mm'" step="60">
                        </div>
                        <div class="to-time">
                            <label>{{alertVarService.titles.templateTitles.advance_filter.end_time}}</label>
                            <input class="input-m" [min]="mindate" [max]="maxdate" type="datetime-local" id="to"
                                formControlName="toDate" [tooltip]="toDate.value | date:'dd MMM yy HH:mm'" step="60">
                        </div>
                    </div>
                    <div class="episode-size">
                        <div class="header content-xl">{{alertVarService.titles.templateTitles.advance_filter.episode_size}}</div>
                        <div class="episode-body">
                            <div class="interval" #severityOrigin>
                                <label for="interval">{{alertVarService.titles.templateTitles.advance_filter.interval}}</label>
                                <app-overlay-select sort="false" formControlName="interval" [data]="advanceFilter_metadata.intervals"
                                    [origin]="severityOrigin" fontsize="content-m" label="" id="interval">
                                </app-overlay-select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
    <div class="bottom-wrapper">
        <div class="error-msg">
            <span class="alert-text content-s">{{Errormsg | oneError:errorObj}}</span>
        </div>
        <div class="closing">
            <button class="submit" (click)="applyClick()">{{alertVarService.titles.templateTitles.advance_filter.apply}}</button>
            <button class="cancel" (click)="cancelClick()">{{alertVarService.titles.templateTitles.advance_filter.cancel}}</button>
        </div>
    </div>
</div>